export const sizes = {
  md: '40px',
  mdd: '48px',
  lg: '64px',
  width: '1300px',
};
